import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import { ApiService } from './api.service';

@Injectable()
export class GesteffortService extends ApiService {
  constructor(private http: Http) {
    super('api/gest-efforts-ship', http);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/gesteffort.service.ts